<mat-expansion-panel
    #expansionPanel
    [expanded]="expanded"
    [hideToggle]="hideToggle"
    [disabled]="disabled"
>
    <mat-expansion-panel-header
        [ngStyle]="disabled ? { cursor: 'default' } : null"
    >
        <mat-panel-title
            class="flex space-x-2 !text-tertiary-900 font-normal text-xl py-2"
        >
            <h1 class="text-tertiary-900 font-normal !text-xl !m-0">
                Search Information
            </h1>
        </mat-panel-title>

        <mat-panel-description>
            @if (!expansionPanel.expanded) {
                {{ expansionPanelDescription }}
            }
        </mat-panel-description>
    </mat-expansion-panel-header>

    <div class="flex justify-evenly items-center w-full mt-2">
        <div class="text-center text-tertiary-900">
            <p class="font-medium !m-0 tracking-wider">Completed</p>

            <time
                [attr.datetime]="completedAt"
                class="block text-lg font-medium text-tertiary-900"
            >
                {{ getFormattedTime(completedAt) }}
            </time>

            <time
                [attr.datetime]="completedAt"
                class="block text-sm text-tertiary-900"
            >
                {{ getFormattedDate(completedAt) }}
            </time>
        </div>

        <app-countdown-ring
            [totalMs]="totalMs"
            [remainingMs$]="remainingMsObservable"
            [percentageRemaining$]="percentRemainingObservable"
            [formatTimeRemainingFn]="getFormattedTimeRemaining.bind(this)"
        ></app-countdown-ring>

        <div class="text-center text-tertiary-900">
            <p class="font-medium !m-0 tracking-wider">Reserved Until</p>

            <time
                [attr.datetime]="reservedUntil"
                class="block text-lg font-medium text-tertiary-900"
            >
                {{ getFormattedTime(reservedUntil) }}
            </time>

            <time
                [attr.datetime]="reservedUntil"
                class="block text-sm text-tertiary-900"
            >
                {{ getFormattedDate(reservedUntil) }}
            </time>
        </div>
    </div>
</mat-expansion-panel>
